import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { OrderService } from 'src/app/core/services/order.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { RedPlates } from 'src/app/shared/model/order.model';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { User } from 'src/app/shared/model/user.model';

@Component({
  standalone: true,
  selector: 'app-red-plates',
  templateUrl: './red-plates.component.html',
  styleUrls: ['./red-plates.component.scss'],
  imports: [CommonModule, I18NextModule, RouterModule, StepperComponent]
})
export class RedPlatesComponent implements OnInit, AfterViewInit {
  user!: User;
  steps = new Map<string, boolean>();
  requestTypeEnum = RequestType;
  landing2 = false;
  loading = false;

  constructor(
    private storageService: StorageService,
    private orderService: OrderService,
    public dialog: MatDialog,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  setSteps() {
    this.steps.set('vehicle-finder', false);
    this.steps.set('approvers', true);
    this.steps.set('request-info', true);
    this.steps.set('car-config', false);
    this.steps.set('replacementvehicle', false);
    this.steps.set('additionalInfo', true);
  }

  sendRequest(newRequestData: RedPlates) {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.loading = true;
      this.orderService.sendRedPlates(newRequestData).subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            }
          });
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            }
          });
        }
      });
    });
  }
}
